import { c as t, a as r, b as e, d as s } from "../../index.esm-YJBIRYbu.js";
import { TrackingEvents as a, eventVersion as i, ProductNames as o } from "./events.js";
const d = t({
  event_type: r().required().oneOf(Object.values(a)),
  event_version: e().required().oneOf(i),
  isTestEvent: s(),
  meta: t({
    user_id: e(),
    session_id: e(),
    page_load_id: e(),
    product_version: e(),
    client_id: e(),
    product_name: r().required().oneOf(Object.values(o))
  }),
  attributes: t({})
});
export {
  d as schema
};
